import { render, staticRenderFns } from "./numericalCode.vue?vue&type=template&id=3020badb&scoped=true&"
import script from "./numericalCode.vue?vue&type=script&lang=js&"
export * from "./numericalCode.vue?vue&type=script&lang=js&"
import style0 from "./numericalCode.vue?vue&type=style&index=0&id=3020badb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3020badb",
  null
  
)

export default component.exports